import * as types from "./mutation_types";
import { Feed } from "../../../../interfaces/feed";

export default {
  [types.FEED_SHOW_RESET](state: any) {
    Object.assign(state, {
      error: "",
      isLoading: false,
      retrieved: null,
    });
  },

  [types.FEED_SHOW_SET_ERROR](state: any, error: any) {
    Object.assign(state, { error });
  },

  [types.FEED_SHOW_SET_RETRIEVED](state: any, retrieved:Feed) {
    Object.assign(state, { retrieved });
  },

  [types.FEED_SHOW_TOGGLE_LOADING](state: any) {
    Object.assign(state, { error: "", isLoading: !state.isLoading });
  },
};
